<rid-categorise-yes-no
  class="h-dvh"
  [questions]="[
    {
      id: 'q1',
      question: 'Bevat deze zin een dubbelzetter?',
      options: [{ type: 'SENTENCE', sentence: 'de kat is blij' }],
      answer: 'NO',
    },
  ]"
  (finished)="$router.navigate(['/mechanics/sorting/yes-or-no'])"
/>
